import styled from 'styled-components'

import { museoFont } from '@h2/components/mixins'
import { BLACK, WHITE } from '@h2/components/colors'
import { Link } from '@h2/common/components/link'
import { Button } from '@h2/components/buttons/button'
import { features } from '@h2/components/media'

import { MuseoHeading } from './museo'

const linkAlignments = {
  right: 'right: 15px;',
  left: 'left: 15px;'
}
const getLinkAlign = ({ align }) => linkAlignments[align] || linkAlignments.right
const StyledLink = styled(Link)`
  ${museoFont}
  ${getLinkAlign}
  font-weight: 500;
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 5px 15px;
  :link {
    text-decoration: none;
  }
  position: absolute;
  bottom: 15px;
  background-color: ${WHITE};
  color: ${BLACK};
  border-radius: 25px;

  :hover,
  :link,
  :visited {
    background-color: ${WHITE};
    color: ${BLACK};
  }
`
const StyledButton = styled(Button)`
  ${museoFont}
  font-weight: 500;
  left: 15px;
  padding: 5px 15px;
  position: absolute;
  bottom: 15px;
  background-color: ${WHITE};
  color: ${BLACK};
  border-radius: 25px;
  border-color: transparent;
  > span {
    display: flex;
    gap: 10px;
    align-items: center;
    font-size: 20px;
    font-weight: 400;
    > span {
      cursor: pointer;
    }
  }

  :hover,
  :link,
  :visited {
    background-color: ${WHITE};
    color: ${BLACK};
  }
`
const getBgImage = ({ bgImage }) =>
  bgImage ? `background-image: url(${bgImage});` : null
const Wrap = styled.div`
  position: relative;
  height: 142px;
  border: ${({ borderColor }) => borderColor} solid 4px;
  padding: 15px;
  background-color: ${({ bgColor }) => bgColor};
  ${getBgImage}
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 10px;
  width: 100%;

  @media (${features.minWidth.widescreen}) {
    width: 335px;
  }
`
const CtaHeading = ({ children, color }) => (
  <MuseoHeading level="3" color={color}>
    {children}
  </MuseoHeading>
)
const CtaLink = ({ children, icon: Icon, align = 'right', ...rest }) => (
  <StyledLink
    variant="button"
    fontSize="20px"
    isHoverStyled={false}
    align={align}
    target="_blank"
    {...rest}>
    {Icon && <Icon size="medium" />}
    {children}
  </StyledLink>
)
const CtaButton = ({ children, onClick = () => {}, icon: Icon }) => (
  <StyledButton onClick={onClick} fontSize="20px">
    {Icon && <Icon size="medium" />}
    {children}
  </StyledButton>
)
const Cta = ({ children, borderColor = BLACK, bgColor = 'transparent', bgImage }) => {
  return (
    <Wrap borderColor={borderColor} bgColor={bgColor} bgImage={bgImage}>
      {children}
    </Wrap>
  )
}

Cta.Heading = CtaHeading
Cta.Link = CtaLink
Cta.Button = CtaButton

export { Cta }
